import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
	setSelectedProductPackage as setSelectedProductPackageAction,
	openPayment as openPaymentAction,
	close as closeAction,
} from "ducks/boosts";

import Screen from "shared/payment/components/Screen";

import Description from "./Description";
import Packages from "./Packages";
import "./ProductPackageScreen.scss";

export const ProductPackageScreen = ({
	selectedProductPackage: { id },
	isLoading,
	productPackages,
	setSelectedProductPackage,
	openPayment,
	close,
}) => {
	return (
		<Screen className="boostpackages">
			<div className="boostpackages-container">
				<Description />
				<Packages
					isLoading={isLoading}
					productPackages={productPackages}
					setSelectedProductPackage={setSelectedProductPackage}
					selectedProductId={id}
					onBoostClick={openPayment}
					toggleVisible={close}
				/>
			</div>
		</Screen>
	);
};

ProductPackageScreen.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	productPackages: PropTypes.array.isRequired,
	selectedProductPackage: PropTypes.object.isRequired,

	setSelectedProductPackage: PropTypes.func.isRequired,
	close: PropTypes.func.isRequired,
	openPayment: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => ({
	...state.boosts,
});

export const mapDispatchToProps = (dispatch) => ({
	setSelectedProductPackage(productPackageId) {
		dispatch(setSelectedProductPackageAction(productPackageId));
	},

	openPayment() {
		dispatch(openPaymentAction());
		dispatch(closeAction());
	},

	close() {
		dispatch(closeAction());
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProductPackageScreen);



// WEBPACK FOOTER //
// ./src/apps/boosts/components/ProductPackageScreen/index.jsx